// AI Generated file
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'monRemoveWhiteSpace',
    standalone: false,
})
export class MonRemoveWhiteSpacePipe implements PipeTransform {
    transform (input: any): any {
        if (typeof input === 'string') {
            return input.replace(/\s+/g, '');
        }
        return input;
    }
}
